module.exports = __webpack_public_path__ + "static/media/main-site.d9e468f0.svg";